import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <div className="pt-16 relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
        <h1 className="absolute bottom-1/3 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <i className="ri-error-warning-line text-5xl text-foreground-400"></i>
          </div>
          <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mt-4">页面未找到</h1>
          <p className="mt-2 text-sm text-foreground-500">您访问的页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-primary-500 text-white rounded-full text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}